import React from "react";
import { MenuItem, Select } from "@mui/material";
import PageHeader from "../../shared/components/PageHeader";

const termLabel = (term) =>
  term ? `${term.name}${term.is_semester_term ? " (semester)" : ""}` : "";

// Page-header definition for the legacy v1 Social Development page. The grade-band
// menu becomes the header tabs and the term picker its only action. Two things
// differ from the other migrated pages and are deliberate:
//   - The tabs drive local `level` state (not navigation), so they call
//     onLevelChange; v1 keeps syncing `?level=` and refetching.
//   - The term selector has no auto-default: this page starts with no term and
//     shows a "select a term" prompt until one is picked, so "Select Term" is a
//     real, selectable value (onTermChange(null)), not just a placeholder.
export default function SocialDevelopmentHeader({
  levels = [],
  activeLevel,
  onLevelChange,
  terms = [],
  selectedTermId,
  onTermChange,
}) {
  const value = terms.some((t) => t.id === selectedTermId)
    ? selectedTermId
    : "";

  return (
    <PageHeader
      title="Social Development/Work Ethic"
      // The tabs drive local `level` state, not navigation: each selects its
      // grade band through onLevelChange (v1 keeps syncing `?level=`).
      tabs={levels.map((lvl) => ({
        key: lvl,
        label: lvl,
        onClick: () => onLevelChange(lvl),
      }))}
      activeTab={activeLevel}
      actions={
        <Select
          size="small"
          value={value}
          onChange={(e) => onTermChange(e.target.value || null)}
          displayEmpty
          inputProps={{ "aria-label": "Term" }}
          renderValue={(v) =>
            termLabel(terms.find((t) => t.id === v)) || "Select Term"
          }
          sx={{ minWidth: 160 }}
        >
          <MenuItem value="">Select Term</MenuItem>
          {terms.map((t) => (
            <MenuItem key={t.id} value={t.id}>
              {termLabel(t)}
            </MenuItem>
          ))}
        </Select>
      }
    />
  );
}
